import React from 'react';

import styled from 'styled-components';

import { renderBoldMarkup } from 'helpers/renderBoldMarkup';
import { formatCountWithUnit } from 'utils/helpers/string';

import {
  USER_MANAGEMENT_FEATURE_FLAGS_BULK_HELP_TEXT,
  USER_MANAGEMENT_FEATURE_FLAGS_BULK_SELECTED_SUFFIX,
  USER_MANAGEMENT_FEATURE_FLAGS_MODAL_TITLE,
  USER_MANAGEMENT_FEATURE_FLAGS_USER_UNIT,
} from './constants';

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const TitleText = styled.span`
  font-family: var(--font-bold);
  font-size: 20px;
  color: var(--text-primary);
`;

const SelectedCount = styled.div`
  font-family: var(--font-medium);
  font-size: 14px;
  color: var(--text-primary);
`;

const BulkHelpText = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.35;

  strong {
    color: var(--text-primary);
    font-family: var(--font-bold);
  }
`;

type Props = {
  isBulkMode: boolean;
  selectedUsersCount: number;
};

const UserManagementFeatureFlagsModalHeader = ({ isBulkMode, selectedUsersCount }: Props) => (
  <TitleContent>
    <TitleText data-test-id="user-management-feature-flags-modal-title">
      {USER_MANAGEMENT_FEATURE_FLAGS_MODAL_TITLE}
    </TitleText>
    {isBulkMode && (
      <>
        <SelectedCount>
          {formatCountWithUnit(selectedUsersCount, USER_MANAGEMENT_FEATURE_FLAGS_USER_UNIT)}{' '}
          {USER_MANAGEMENT_FEATURE_FLAGS_BULK_SELECTED_SUFFIX}
        </SelectedCount>
        <BulkHelpText>{renderBoldMarkup(USER_MANAGEMENT_FEATURE_FLAGS_BULK_HELP_TEXT)}</BulkHelpText>
      </>
    )}
  </TitleContent>
);

export default UserManagementFeatureFlagsModalHeader;
